module.exports = __webpack_public_path__ + "media/images/athletes/2029-a82adf139e1d004d3c5c31795b501c26.png";